import { render, staticRenderFns } from "./PatientImport.vue?vue&type=template&id=674bd115&scoped=true&"
import script from "./PatientImport.vue?vue&type=script&lang=ts&"
export * from "./PatientImport.vue?vue&type=script&lang=ts&"
import style0 from "./PatientImport.vue?vue&type=style&index=0&id=674bd115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674bd115",
  null
  
)

export default component.exports